'use client';

import React from 'react';
import { faExternalLinkAlt } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon as Icon } from '@fortawesome/react-fontawesome';
import { Typography } from 'src/components/PulseUI';

interface InstitutionCellProps {
  row: any;
}

/**
 * Education table cell showing the institution name and, when the backend
 * supplies a `freida_program_url`, an external link to the program's FREIDA
 * page. The link stops propagation so clicking it doesn't select the grid row.
 */
const InstitutionCell: React.FC<InstitutionCellProps> = ({ row }) => {
  const url = row?.freida_program_url;
  const label = row?.institution || 'n/a';

  return (
    <Typography variant="body2" truncate>
      {url ? (
        <a
          href={url}
          target="_blank"
          rel="noopener noreferrer"
          data-testid="freida-program-link"
          className="text-sky-900"
          onClick={(clickEvent) => clickEvent.stopPropagation()}
        >
          {label}
          <Icon icon={faExternalLinkAlt} size="sm" className="ml-1" />
        </a>
      ) : (
        label
      )}
    </Typography>
  );
};

export default InstitutionCell;
